import {SequenceSummary} from 'constants/SequenceConstants';
import * as TaskRunner from 'util/TaskRunner';

export interface AutoFillSequenceResponse {
  sequenceSummary: SequenceSummary;
  didModifySequence: boolean;
  warningMessages: Array<string>;
  autofillCount?: number;
}

export interface AutoFillPartsSequenceResponse extends AutoFillSequenceResponse {
  overloadedFields: Array<string>;
}

export interface AutoFillFeatureResponse {
  [sequenceId: string]: AutoFillSequenceResponse;
}

export interface AutoFillPartsResponse {
  [sequenceId: string]: AutoFillPartsSequenceResponse;
}

export function autofillParts(sequenceIds: Array<string>): Promise<AutoFillPartsResponse> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/sequences/actions/auto-fill-part-fields',
    data: {containerSequenceIds: sequenceIds},
  });
}

export function autofillTranslations(sequenceIds: Array<string>): Promise<AutoFillFeatureResponse> {
  return TaskRunner.postJSONPromise({url: '/1/api/sequences:autofill-translations', data: {sequenceIds}});
}

export function autofillTranscriptions(sequenceIds: Array<string>): Promise<AutoFillFeatureResponse> {
  return TaskRunner.postJSONPromise({url: '/1/api/sequences:autofill-transcriptions', data: {sequenceIds}});
}
